import { render, staticRenderFns } from "./process-nfr-request.vue?vue&type=template&id=71144713&"
import script from "./process-nfr-request.vue?vue&type=script&lang=tsx&"
export * from "./process-nfr-request.vue?vue&type=script&lang=tsx&"
import style0 from "./process-nfr-request.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports